import { getFirstModuleEncId } from "@/utils/initEv.js"
import { deepChangeUid } from "utils"
import store from "../store"
import api from "@/api/index"
const getParam = async (params, isClone) => {
  return api.createComponentApp({
    param: params
  })
}
class leftMenuReadyCache {
  constructor() {
    this.readyCache = {

    },
    this.originMenuMap = {

    }
  }
  async getOriginMenuData(typeId) {
    let childItem = await getFirstModuleEncId(typeId)
    this.originMenuMap[typeId] = JSON.stringify(childItem)
    return childItem
  }
  getReadyMenuData(typeId, typeName) {
    if (this.readyCache[typeId]) {
      const cacheData = this.readyCache[typeId]
      requestIdleCallback(() => {
        this.readyCache[typeId] = null
        this.getReadyData(typeId, typeName)
      })
      return cacheData
    }
  }
  resetRectAttrOpt(childItem, _attribute) {
    let layoutUidMap = {}
    childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
    childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
    // this.doAdd = true
    //鼠标移动处理
    if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
      _attribute.options.width = 414
    }
    if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
      //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
      layoutUidMap = deepChangeUid(_attribute)
    }
    _attribute.options.layoutUidMap = layoutUidMap
    return _attribute
  }
  async getReadyData(typeId, typeName) {
    let originMenuData = null
    if (this.originMenuMap[typeId]) {
      originMenuData = JSON.parse(this.originMenuMap[typeId])
    } else {
      originMenuData = await this.getOriginMenuData(typeId)
    }
    let _attribute = originMenuData.content
    if (typeName === '图文列表' || typeName === '文本列表') {
      // 深度递归修改uid
      _attribute = this.resetRectAttrOpt(originMenuData, _attribute)
      const appId = _attribute.options.appId ? _attribute.options.appId : _attribute.options.myFetchParam?.appId
      const { pageId } = store.state.states.getDataPageIds
      const params = {
        a: appId ? appId : "7C5C8F204A2F4171", // 先判断当前是否传递了appId
        w: -10,
        p: pageId,
        c: {},
        t2: "31CB73E03E24BBFF",
        t: "临时",
        clone: false
      }
      const appIdRes = await getParam(params, false)
      const replacedAppId = appIdRes.data.data.appId
      _attribute.options.appId = replacedAppId
      this.readyCache[typeId] = JSON.stringify(_attribute)
    }
  }
  destroy() {
    this.readyCache = null
    this.originMenuMap = null
  }
}
const leftMenuCache = {

}

const menuReadyCache = new leftMenuReadyCache()

export default leftMenuCache
export { menuReadyCache }

